import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { API_ENDPOINTS } from "./Utils/endpoints";

export const GetManufactureJournalDetail = (params: any) =>
   GET_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.GET + params, null);

export const GetManufactureJournalList = (params: any) =>
   GET_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.LIST  + params, null);

export const CreateManufactureJournal = (data: any) =>
  POST_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.CREATE, data);

export const UpdateManufactureJournal = (data: any) =>
  POST_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.UPDATE, data);

export const DeleteManufactureJournal = (data: any) =>
  POST_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.DELETE, data);

export const GetManufactureJournalVoucherNumber = (params: any) =>
   GET_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.GET_VOUCHER_NO + params, null);

export const ApproveManufactureJournal = (data: any) =>
  POST_ENC(API_ENDPOINTS.MANUFACTURING_JOURNAL.APPROVE, data);